(function() {
  'use strict';

  // Use the CART tracking sheet URL (same as add-to-cart and collection page tracking)
  const GOOGLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbxz2q4k0EPnIv5DzWU88pvTjdMK01W0aHyiPsGFxqIOS-4UxM2CGKaz_g42XTunSno_/exec';
  const NEW_GOOGLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbwBM5O-AMKHU-zYpELpgMr5edFhI_pSd4HLAhOgC8ESZPcZ-sWsdKGFLT30oXzaViMw/exec';
  
  let modalOpened = false; // Track if modal was opened
  let emailSubmitted = false; // Track if email was submitted
  let productHandle = '';
  let productTitle = '';

  function hasSubmittedMeasurementsForCurrentProduct() {
    if (!productHandle) return false;
    const storageKey = 'custom-measurements-' + productHandle;
    return localStorage.getItem(storageKey) === 'true';
  }

  function hasCustomAccess() {
    return Boolean(checkExistingEmail() || hasSubmittedMeasurementsForCurrentProduct());
  }

  // Initialize with product data
  window.initCustomButtonLock = function(handle, title) {
    productHandle = handle;
    productTitle = title;
    console.log('🔒 Initializing Custom button lock feature...');
    
    // Find all Custom variant buttons
    const customButtons = findCustomButtons();
    console.log('Found Custom buttons:', customButtons.length);
    
    // Access is granted if we have email OR measurements already submitted for this product
    const hasAccess = hasCustomAccess();
    
    // Always wrap the buttons (they need the click handler for measurement checks)
    customButtons.forEach(button => {
      wrapCustomButton(button);
    });
    
    if (hasAccess) {
      console.log('✅ Access already available - Unlocking Custom buttons immediately');
      unlockAllCustomButtons();
    } else {
      console.log('🔒 No measurements yet - Custom buttons remain locked');
    }
    
    // Listen for email updates from other features
    window.addEventListener('email-updated', function(event) {
      console.log('📧 Email updated - unlocking Custom buttons');
      unlockAllCustomButtons();
    });

    // Unlock immediately when custom measurements are submitted.
    window.addEventListener('custom-measurements-submitted', function(event) {
      const submittedHandle = event && event.detail ? event.detail.productHandle : null;
      if (!submittedHandle || submittedHandle === productHandle) {
        console.log('📏 Measurements submitted - unlocking Custom button');
        unlockAllCustomButtons();
      }
    });
    
    // Periodic check to maintain lock state (every 500ms)
    setInterval(function() {
      const wrappers = document.querySelectorAll('.custom-button-wrapper');
      
      // If wrappers exist, check and maintain lock state
      if (wrappers.length > 0) {
        const hasAccess = hasCustomAccess();
        
        if (hasAccess) {
          wrappers.forEach(wrapper => {
            if (!wrapper.classList.contains('unlocked')) {
              wrapper.classList.add('unlocked');
            }
          });
        } else {
          wrappers.forEach(wrapper => {
            if (wrapper.classList.contains('unlocked')) {
              wrapper.classList.remove('unlocked');
            }
          });
        }
      } else {
        // Wrappers were removed (variant changed) - re-wrap Custom buttons
        const customButtons = findCustomButtons();
        if (customButtons.length > 0) {
          console.log('🔧 Re-wrapping Custom buttons after variant change');
          customButtons.forEach(button => {
            wrapCustomButton(button);
          });
          
          const hasAccess = hasCustomAccess();
          if (hasAccess) {
            unlockAllCustomButtons();
          }
        }
      }
    }, 500);
    
    // Check if we should auto-open measurement modal (coming from collection page)
    const shouldOpenModal = sessionStorage.getItem('openMeasurementModal');
    
    if (shouldOpenModal && shouldOpenModal === productHandle) {
      console.log('📝 Auto-opening measurement modal from collection page redirect');
      sessionStorage.removeItem('openMeasurementModal');
      
      setTimeout(() => {
        if (typeof openCustomSizingGuide === 'function') {
          openCustomSizingGuide();
        } else {
          console.error('⚠️ openCustomSizingGuide function not found');
        }
      }, 500);
    }
  };

  function findCustomButtons() {
    const buttons = [];
    
    console.log('🔍 Searching for Custom variant buttons...');
    
    // Strategy 1: Find ALL radio inputs in variant pickers
    const allRadios = document.querySelectorAll('input[type="radio"]');
    console.log('Total radio inputs found:', allRadios.length);
    
    allRadios.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        const labelText = label.textContent.trim().toLowerCase();
        console.log('Radio label text:', labelText);
        // Check if label starts with "custom" (handles "customvariant sold out or unavailable")
        if (labelText.startsWith('custom')) {
          console.log('✅ Found Custom radio button!', input.id);
          buttons.push({ type: 'radio', input, label });
        }
      }
    });
    
    // Strategy 2: Find swatch buttons (for swatch-style pickers)
    const swatchInputs = document.querySelectorAll('input.color-swatch__radio, input[class*="swatch"]');
    console.log('Swatch inputs found:', swatchInputs.length);
    
    swatchInputs.forEach(input => {
      if (input.value && input.value.toLowerCase().startsWith('custom')) {
        const label = document.querySelector(`label[for="${input.id}"]`);
        console.log('✅ Found Custom swatch!', input.id);
        buttons.push({ type: 'swatch', input, label });
      }
    });
    
    // Strategy 3: Direct label search as fallback
    const allLabels = document.querySelectorAll('label');
    allLabels.forEach(label => {
      const text = label.textContent.trim().toLowerCase();
      if (text.startsWith('custom') && label.getAttribute('for')) {
        const input = document.getElementById(label.getAttribute('for'));
        if (input && input.type === 'radio' && !buttons.find(b => b.input === input)) {
          console.log('✅ Found Custom via label search!', label.getAttribute('for'));
          buttons.push({ type: 'radio', input, label });
        }
      }
    });
    
    console.log('Total Custom buttons found:', buttons.length);
    return buttons;
  }

  function wrapCustomButton(buttonObj) {
    console.log('🎯 Attempting to wrap Custom button:', buttonObj);
    
    const targetElement = buttonObj.label || buttonObj.button;
    if (!targetElement) {
      console.warn('⚠️ No target element found for wrapping');
      return;
    }
    
    // Check if already wrapped
    if (targetElement.closest('.custom-button-wrapper')) {
      console.log('Already wrapped, skipping');
      return;
    }
    
    console.log('Wrapping element:', targetElement);
    
    // Need to wrap both input and label to maintain their sibling relationship for CSS
    const input = buttonObj.input;
    
    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-button-wrapper';
    
    // Create lock overlay with SVG
    const overlay = document.createElement('div');
    overlay.className = 'custom-button-lock-overlay';
    overlay.innerHTML = `
      <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
      </svg>
    `;
    
    // Add click listener to wrapper (entire button area)
    wrapper.addEventListener('click', function(e) {
      if (!wrapper.classList.contains('unlocked')) {
        // Button is locked - open measurement form directly (no email popup)
        console.log('🔒 Locked Custom button clicked - opening measurement form directly');
        e.preventDefault();
        e.stopPropagation();
        if (typeof openCustomSizingGuide === 'function') {
          openCustomSizingGuide();
        }
      } else {
        // Button is unlocked - check if measurements were submitted for this product
        const storageKey = 'custom-measurements-' + productHandle;
        const measurementsSubmitted = localStorage.getItem(storageKey) === 'true';
        console.log('🔓 Unlocked button click | Product:', productHandle, '| Key:', storageKey, '| Submitted:', measurementsSubmitted);
        
        if (measurementsSubmitted) {
          // Measurements already submitted - ask if they want to update
          console.log('✅ Measurements already exist - showing confirmation');
          e.preventDefault();
          e.stopPropagation();
          
          const confirmation = confirm('You already have measurements saved for this dress. Do you want to update them?');
          if (confirmation) {
            if (typeof openCustomSizingGuide === 'function') {
              openCustomSizingGuide();
            }
          } else {
            // User clicked "No" - select the Custom variant
            console.log('🎯 User clicked No - selecting Custom variant...');
            if (typeof window.selectCustomVariant === 'function') {
              setTimeout(() => {
                window.selectCustomVariant();
              }, 100);
            } else {
              console.error('❌ selectCustomVariant function not found!');
            }
          }
        } else {
          // Measurements not submitted for this product - open custom sizing guide modal
          console.log('📏 Custom button clicked but no measurements for this product - opening form...');
          e.preventDefault();
          e.stopPropagation();
          
          if (typeof openCustomSizingGuide === 'function') {
            openCustomSizingGuide();
          }
        }
      }
    });
    
    // Wrap both input and label to maintain their adjacency for CSS
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    wrapper.appendChild(targetElement);
    wrapper.appendChild(overlay);
    
    console.log('✅ Successfully wrapped Custom button with lock overlay');
  }

  function checkExistingEmail() {
    // Check Shopify customer
    if (typeof Shopify !== 'undefined' && Shopify.customer && Shopify.customer.email) {
      return Shopify.customer.email;
    }
    
    // Check localStorage
    const wishlistEmail = localStorage.getItem('shopify-wishlist-email');
    const customEmail = localStorage.getItem('custom-size-email');
    
    return wishlistEmail || customEmail || null;
  }

  async function postToCartTrackingSheets(payload) {
    const requests = [
      fetch(GOOGLE_SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }),
      fetch(NEW_GOOGLE_SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
    ];

    const results = await Promise.allSettled(requests);
    const oldOk = results[0].status === 'fulfilled';
    const newOk = results[1].status === 'fulfilled';
    console.log('✅ Custom tracking status | old:', oldOk, '| new:', newOk);
  }

  window.openCustomEmailModal = function() {
    // Legacy safety path: if any old code calls this, bypass popup and open form directly.
    if (typeof openCustomSizingGuide === 'function') {
      openCustomSizingGuide();
    }
  };

  // Define trackCustomDenial BEFORE closeCustomEmailModal (needs to be available when called)
  async function trackCustomDenial() {
    try {
      const payload = {
        email: 'Custom Denied',
        productHandle: productHandle,
        productName: productTitle,
        productSize: 'Custom (Locked - Denied)',
        productLink: window.location.href,
        country: typeof Shopify !== 'undefined' && Shopify.country ? Shopify.country : 'India',
        emailSource: 'Custom Denied'
      };
      
      console.log('📤 Tracking custom denial to Google Sheets:', payload);
      
      await postToCartTrackingSheets(payload);
      
      console.log('✅ Custom denial tracked to Google Sheets');
    } catch (err) {
      console.error('❌ Error tracking denial:', err);
    }
  }

  window.closeCustomEmailModal = function() {
    const modal = document.getElementById('custom-email-modal');
    if (modal && modal.classList.contains('active')) {
      // Track denial if modal was opened but email not submitted
      if (modalOpened && !emailSubmitted) {
        console.log('🚫 User closed modal without entering email - tracking denial');
        trackCustomDenial();
      }
      
      modal.classList.remove('active');
      modalOpened = false; // Reset flag
    }
  };

  window.submitCustomEmail = async function() {
    const input = document.getElementById('custom-email-input');
    const email = input.value.trim();
    
    if (!email) {
      alert('Please enter your email');
      return;
    }
    emailSubmitted = true; // Mark that email was submitted
    
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    console.log('📧 Saving custom size email:', email);
    
    // Save to localStorage
    localStorage.setItem('custom-size-email', email);
    localStorage.setItem('shopify-wishlist-email', email); // Sync with wishlist
    localStorage.setItem('shopify-email-source', 'Custom'); // Save source
    
    // Fire email-updated event for cross-feature sync
    window.dispatchEvent(new CustomEvent('email-updated', {
      detail: { email, source: 'Custom' }
    }));
    
    // Track to Google Sheets
    await trackCustomEmailToSheet(email);
    
    // Unlock all custom buttons
    unlockAllCustomButtons();
    
    // Close email modal
    closeCustomEmailModal();
    
    // Check if measurements form was already submitted for this product
    const storageKey = 'custom-measurements-' + productHandle;
    const measurementsSubmitted = localStorage.getItem(storageKey) === 'true';
    console.log('📝 After email submit | Product:', productHandle, '| Key:', storageKey, '| Already submitted:', measurementsSubmitted);
    
    if (measurementsSubmitted) {
      // Already submitted measurements for this product, just show success
      console.log('✅ Measurements exist for this product - skipping form');
      alert('✅ Custom size unlocked! You can now select custom sizing.');
    } else {
      // First time for this product - open custom sizing guide modal for measurements
      console.log('📏 Opening custom sizing guide for measurements...');
      if (typeof openCustomSizingGuide === 'function') {
        setTimeout(() => {
          openCustomSizingGuide();
        }, 150);
      }
    }
  };

  async function trackCustomEmailToSheet(email) {
    try {
      const payload = {
        email: email,
        productHandle: productHandle,
        productName: productTitle,
        productSize: 'Custom (Unlocked)',
        productLink: window.location.href,
        country: typeof Shopify !== 'undefined' && Shopify.country ? Shopify.country : 'India',
        emailSource: 'Custom'
      };
      
      console.log('📤 Sending custom email to Google Sheets:', payload);
      console.log('📍 Sheet URL:', GOOGLE_SHEET_URL);
      console.log('📍 New Sheet URL:', NEW_GOOGLE_SHEET_URL);
      
      await postToCartTrackingSheets(payload);
      
      console.log('✅ Custom email tracked to Google Sheets');
    } catch (err) {
      console.error('❌ Error tracking to sheet:', err);
      console.error('Error details:', err.message);
    }
  }

  function unlockAllCustomButtons() {
    const wrappers = document.querySelectorAll('.custom-button-wrapper');
    wrappers.forEach(wrapper => {
      wrapper.classList.add('unlocked');
    });
    console.log('🔓 All Custom buttons unlocked');
  }
})();
